let formValidation = new Map();
formValidation.set('defaultFormValidation',"[A-Za-z0-9 ]*");
formValidation.set('bankAccNo',"(?!^0*$)[0-9]{6,}");

let errorMessage = new Map();
errorMessage.set('defaultFormValidation',"form.validation.error");
errorMessage.set('bankAccNo',"form.validation.error.bankAccNo");

let blackListed = new Map();
blackListed.set('defaultFormValidation',"/,<>()[]");
blackListed.set('bankAccNo',"A-Z a-z");

function getFormValidation(key){
    if(formValidation.has(key)){
        return formValidation.get(key);
    }
    else
        return formValidation.get('defaultFormValidation');
}

function getBlacklisted(key){
    let val;
    let regex="[";
    if(blackListed.has(key)){
        val = blackListed.get(key);
    }
    else
        val = blackListed.get('defaultFormValidation');
    
    regex+=val+"]";
    return regex;
}

function getErrorMessage(key){
    if(errorMessage.has(key)){
        return errorMessage.get(key);
    }
    else
        return errorMessage.get('defaultFormValidation');
}

export default {
    getFormValidation : getFormValidation,
    getErrorMessage : getErrorMessage,
    getBlacklisted : getBlacklisted
};